import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';

class EntriesBoys extends React.Component {
    render() {
        const { teams = [] } = this.props;
        return (
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} delay={100}>
                <Title text={`BOYS`} sub={`(${teams.length})`} className="black margin-top" />
                <table className="w3-table w3-content w3-bordered font-12 bg-white margin-top table table-striped" >
                    <thead>
                        <tr className="w3-black">
                            <th>DIVISION</th>
                            <th className="text-left">TEAM</th>
                            <th className="text-center">ID</th>
                            <th className="text-left">COACH</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teams.map((team, index) => <tr key={index}>
                            <td>{team.DivisionName}</td>
                            <td className="text-left">{team.TeamName}</td>
                            <td className="text-center">{team.IdTeam}</td>
                            <td className="text-left">{(_.first(team.roster) || {}).NameLast}</td>
                        </tr>)}
                    </tbody>
                </table>
            </ScrollAnimation>
        )
    }
}

export default EntriesBoys;


// WEBPACK FOOTER //
// ./src/components/tournaments/partials/entries_boys.js